import styled, { css } from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getTextTokenPreset, getToken, Sized, Status } from '@optimus-web/common';
import { IconName } from '@optimus-web/icons';
import { ANIMATION_CURVE, ANIMATION_DURATION } from '@optimus-web/local-tokens';
import { Stack } from '../../Stack';
import { ErrorIcon } from '../ErrorIcon';

interface FormMessageElementProps extends Sized {
    status?: Status;
    id?: string;
}

interface FormMessageProps extends FormMessageElementProps {
    children: React.ReactNode;
}

export const FormMessageElement = styled(Stack)<FormMessageElementProps>`
    ${getTextTokenPreset('BODY_M')};
    color: ${getToken(TokenName.TEXT_STATIC_SECONDARY)};
    margin-top: ${(props) =>
        props.size === 'large'
            ? `${getToken(TokenName.SPACING_100)(props)}px`
            : `${getToken(TokenName.SPACING_50)(props)}px`};
    transition-duration: ${ANIMATION_DURATION.default}ms;
    transition-property: color;
    transition-timing-function: ${ANIMATION_CURVE.default};

    ${({ status, theme }) =>
        status === Status.Error &&
        css`
            color: ${theme.designTokens.TEXT_ALERT_DANGER};
        `}
`;

const ErrorMessageContainer = styled.div`
    align-self: center;
`;

const FormMessageErrorIcon = styled(ErrorIcon)`
    margin-right: ${getToken(TokenName.SPACING_150)}px;
`;

export const FormMessage = ({ children, size, status, ...other }: FormMessageProps) => (
    <FormMessageElement spacing="0" size={size} status={status} aria-live="polite" {...other}>
        {status === Status.Error ? <FormMessageErrorIcon value={IconName.ErrorCircle} size="small" /> : null}
        <ErrorMessageContainer>{children}</ErrorMessageContainer>
    </FormMessageElement>
);
